import React, { useState, useEffect } from "react";
import "../../pages/styles.css";
import ArtistCard from "./artistcard.js";
import axios from "axios";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import Loading from '../../components/Loading'; // Loading 컴포넌트 import
import ErrorState from '../../components/ErrorState';
import InfiniteScroll from "react-infinite-scroll-component";
import { API_BASE } from "../../config";

const Landing = () => {
  //const { t } = useTranslation();
  useEffect(() => {
    document.title = "브이라이브 아카이브 by 덕질코리아";
  }, []);

  const [channelList, setChannelList] = React.useState([]);

  const [renderNum, setRenderNum] = React.useState(20);
  const [hasMore, setHasMore] = useState(true);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  // True once the first channel page has resolved. Distinguishes "still doing
  // the very first load" from "a search legitimately returned zero results" —
  // without it, an empty search wipes the list and shows Loading forever.
  const [initialLoaded, setInitialLoaded] = useState(false);

  const fetchNextData = () => {
    setRenderNum(renderNum + 20);
  };

  useEffect(() => {
    let cancelled = false;
    setError(false);
    axios
      .get(`${API_BASE}/channels?page=${renderNum / 20}`)
      .then(function (response) {
        if (cancelled) return;
        setChannelList((channelList) => [...channelList, ...response.data]);
        setInitialLoaded(true);
      })
      .catch(function (error) {
        if (cancelled) return;
        setError(true);
      });

    return () => {
      cancelled = true;
    };
  }, [renderNum, attempt]);

  // Only block the whole page on the very first load; a failed infinite-scroll
  // page (or an empty search result) should not wipe the page and search box.
  if (!initialLoaded && error) {
    return (
      <ErrorState
        message="채널 목록을 불러오지 못했습니다."
        onRetry={() => setAttempt((a) => a + 1)}
      />
    );
  }

  if (!initialLoaded) {
    return <Loading />; // 로딩 애니메이션 사용
  }

  const handleSearch = (value) => {
    setHasMore(value.length === 0);

    if (value.length === 1) return;
    axios
      .get(`${API_BASE}/channels/search?q=${encodeURIComponent(value)}`)
      .then(function (response) {
        setChannelList(response.data);
      })
      .catch(function (error) {});
  };

  return (
    <>
      <div className="GlobalLayoutView_layout_container__kUnkV GlobalLayoutView_-min_width_745__06yCp">
        <div className="body">
          <div className="HomePageView_container__Gk7q3">
            <div className="HomePageView_home_main__JwIMd">
              <div>
                <div className="HomeComponentView_component_area__nBJJk">
                  <strong className="HomeComponentView_title__wTRwM">
                    브이앱 아카이브 by 덕질코리아
                  </strong>
                  <TextField
                    label="검색"
                    sx={{ mt: 2 }}
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                  <div className="HomeComponentView_component__oey5Q">
                    <ul>
                      {channelList.length === 0 ? (
                        <li style={{ padding: "24px 4px", color: "#888", listStyle: "none" }}>
                          검색 결과가 없습니다.
                        </li>
                      ) : (
                        <InfiniteScroll
                          className="HomeArtistListSlotView_artist_list__3fPzz"
                          dataLength={renderNum}
                          next={fetchNextData}
                          hasMore={hasMore}
                          loader={<h4>브이라이브 아카이브 by 덕질코리아</h4>}
                        >
                          {channelList.map((channel, key) => (
                            <ArtistCard channel={channel} key={key} />
                          ))}
                        </InfiniteScroll>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Landing;
